<template>
  <div class="container-fluid pb-4 f14 color-black">
    <div class="row mb-4">
      <div class="col-lg-12 col-xs-12">
        <h4 class="color-dark-purple mt-3">ADICIONAR HISTÓRICO PROFISSIONAL</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">CARGO</span>
        <span class="color-red font-weight-bold">*</span>
        <div>
          <VueSuggestion
            style="text-transform: capitalize"
            searchURL="/occupations"
            responseDataName="occupations"
            v-model="occupation.name"
            :selectedEl="occupation"
            :whenSelected="
              (item) => {
                occupation = item;
              }
            "
            placeholder="ENGENHEIRO, WEB DESIGNER, EDUCADOR, ETC...."
            classes="mt-1"
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">CIDADE</span>
        <span class="color-red font-weight-bold">*</span>
        <VueSuggestion
                searchURL="/cities"
                responseDataName="cities"
                :focusOut="hasCity"
                :selectedEl="city"
               
                :whenSelected="setCity"
                placeholder="CIDADE ATUAL"
                classes="mt-1"
              />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-4 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">EMPRESA</span>
        <span class="color-red font-weight-bold">*</span>
        <VueSuggestion
          style="text-transform: capitalize"
          searchURL="/companies"
          responseDataName="companies"
          v-model="company.name"
          :selectedEl="company"
          :whenSelected="
            (item) => {
              company = item;
            }
          "
          placeholder="EMPRESA QUE VOCÊ TRABALHOU..."
          classes="mt-1"
        />
      </div>

      <div class="col-lg-4 col-xs-12">
        <span
          class="font-weight-bold ml-2 mb-2"
          :class="{ 'text-danger': errors.start_date }"
        >
          INÍCIO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            type="text"
            class="vs__input"
            v-mask="['##/####']"
            placeholder="MÊS/ANO"
            @focus="errors.start_date = false"
            v-model="start_date"
            :class="{ 'is-invalid': errors.start_date }"
            required
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <span
          class="ml-2 mb-2"
          :class="[
            current_job ? 'color-grey' : 'font-weight-bold',
            errors.end_date ? 'text-danger' : '',
          ]"
        >
          FIM
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            type="text"
            class="vs__input"
            :class="{ 'is-invalid': errors.end_date }"
            :disabled="current_job"
            v-mask="['##/####']"
            placeholder="MÊS/ANO"
            v-model="end_date"
            @focus="errors.end_date = false"
            :required="current_job ? false : true"
          />
        </div>
        <div class="mt-2">
          <SwitchCheckbox
            v-model="current_job"
            :value="current_job"
            label="AINDA TRABALHA AQUI?"
          />
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-12 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">DESCRIÇÃO</span>
        <div class="mt-1">
          <textarea
            style="height: 100px; border-radius: 5px"
            class="full form-control"
            v-model="description"
            cols="30"
            rows="10"
          ></textarea>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12 mt-2">
        <button
          class="btn-add-items-tb bg-purple color-white right"
          style="min-width: 300px"
          @click="createOrUpdate()"
        >
          SALVAR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSuggestion from "components/VueSuggestion.vue";
import SwitchCheckbox from "../../../../pages/Recruiters/Jobs/SwitchCheckbox.vue";

import { mask } from "vue-the-mask";
import { format, min } from "date-fns";
import axios from "axios";

export default {
  props: ["experience_id", "candidate_id", "account_uid"],
  components: { VueSuggestion, SwitchCheckbox },
  created() {
    if (!this.candidate_id) this.url = "/candidates/experiences";
    if (this.experience_id) {
      axios.get(`${this.url}/${this.experience_id}`).then((response) => {
        let experience = response.data.experience;
        let city_name = experience.city_name + " / " + experience.state_uf;

        this.occupation.id = experience.occupation_id;
        this.occupation.name = experience.occupation_name;
        this.company.id = experience.company_id;
        this.company.name = experience.company_name;
        (this.start_date = format(new Date(experience.start_work), "MM/yyyy")),
          (this.end_date = experience.end_work
            ? format(new Date(experience.end_work), "MM/yyyy")
            : ""),
          (this.city.id = experience.city_id);
        (this.city.name = city_name !== "null / null" ? city_name : ""),
          (this.current_job = experience.current_job);
        this.description = experience.description;
      });
    }
  },
  data: () => ({
    url: "/recruiters/talent_banks/experiences",
    occupation: {
      id: 0,
      name: "",
    },
    company: {
      id: 0,
      name: "",
    },
    start_date: "",
    end_date: "",
    city: {
      id: 0,
      name: "",
    },
    current_job: false,
    description: "",
    errors: {
      start_date: false,
      end_date: false,
    },
  }),
  computed: {
    params() {
      let experiences = {
        current_job: this.current_job,
        description: this.description,
        candidate_id: this.candidate_id,
        start_work: this.formatDate(this.start_date),
        end_work: this.current_job ? null : this.formatDate(this.end_date),
        occupation: this.occupation.name.toLowerCase(),
        company: this.company.name.toLowerCase(),
        city_id: this.city.id,
        account_id: this.account_uid,
      };
      return experiences;
    },
  },
  methods: {
    setCity(event) {
      this.city.id = event.id;
      this.city.name = event.title;
    },
    createOrUpdate() {
      if (!this.validDate(this.start_date, "start_date")) return;
      if (!this.current_job) {
        if (!this.validDate(this.end_date, "end_date")) return;
      }
      if (!this.validForm()) return;

      if (this.experience_id) {
        this.updateExperience();
        return;
      }

      this.createExperience();
    },
    createExperience() {
      axios
        .post(`${this.url}`, {
          experiences: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
          if (!this.candidate_id) eventBus.$emit("registerExperience");
        });
    },
    updateExperience() {
      axios
        .put(`${this.url}/${this.experience_id}`, {
          experiences: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    sendFeedback(status) {
      if (!status) {
        this.$toast.error("Sinto muito, não foi possivel salvar.");
        return;
      }

      this.$toast.success("Histórico salvo com sucesso!");
      eventBus.$emit("getExperiences");
      eventBus.$emit("updateInfo");
      this.$modal.hideAll();
    },
    formatDate(dateStr) {
      let month = dateStr.slice(0, dateStr.indexOf("/"));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      return year.concat("/", month, "/01");
    },
    validDate(dateStr, field) {
      if (dateStr.length === 0) {
        // this.$toast.error("Por favor, preencha o campo corretamente.");
        // this.errors[field] = true;
        // return false;
        return true;
      }

      let month = parseInt(dateStr.slice(0, dateStr.indexOf("/")));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      if (month === 0 || month > 12) {
        this.$toast.error("Data invalida.");
        this.errors[field] = true;
        return false;
      }

      if (year <= 1960 || year >= 2050) {
        this.$toast.error("Data invalida, insira um ano valido.");
        this.errors[field] = true;
        return false;
      }

      return true;
    },
    validForm() {
      let fields = [
        { name: "Cargo", value: this.occupation.name },
        { name: "Empresa", value: this.company.name },
        { name: "Inicio", value: this.start_date },
        { name: "Fim", value: this.end_date, ignore: this.current_job },
      ];

      if (this.city.id === 0) {
        this.$toast.error(`O campo "Cidade" não pode ficar vazio.`);
        return false;
      }

      for (let field of fields) {
        if (field.ignore) continue;
        if (field.value.length === 0) {
          this.$toast.error(`O campo "${field.name}" não pode ficar vazio.`);
          return false;
        }
      }

      return true;
    },
    hasCity(event, items, select) {
      if(select){
        this.city.id = select.id;
        this.city.name = select.name;
      }else{
        this.city = items[0] ? items[0] : { id: 0, name: "" };
      }
      if (!this.city)
        this.$toast.error("Por favor, informe a cidade de candidato(a).");
    }
  },
};
</script>
